'use client';

import Image from 'next/image'
import styles from './index.module.scss';
import logo from '@/app/images/logo.png';
import {useState, useCallback, useEffect, useRef} from "react";
import MainButton from "@/app/_components/Shared/MainButton";
import {navItems} from "./data";
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export default function Nav() {
    const pathname = usePathname();
    const path = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
    const [showMobileNav, setShowMobileNav] = useState(false);
    const navRef = useRef(null);

    const items = useCallback((className, isMobile = false) => {
        return <ul className={className}>
            {navItems.map((item, index) => (
                <li key={index}>
                    <Link href={item.link} className={item.link === path ? styles.active : ''}>{item.text}</Link>
                </li>
            ))}
            {isMobile && (
                <li className={styles.mobileButtons}>
                    <MainButton color="primary">Login</MainButton>
                    <MainButton color="info">Sign Up</MainButton>
                </li>
            )}
        </ul>;
    }, [path]);

    const toggleMobileNav = useCallback(() => {
        setShowMobileNav(!showMobileNav);
    }, [showMobileNav]);

    // hide mobile nav on route change
    useEffect(() => {
        setShowMobileNav(false);
    }, [path]);

    // hide mobile nav on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setShowMobileNav(false);
            }
        };

        if (showMobileNav) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showMobileNav]);

    // hide mobile nav on resize
    useEffect(() => {
        const hideMobileNav = () => setShowMobileNav(false);
        window.addEventListener('resize', hideMobileNav);
        return () => window.removeEventListener('resize', hideMobileNav);
    }, []);

    return (
        <header className={styles.header} ref={navRef}>
            <div className={styles.headerContent}>
                <Link href="/" className={styles.logoLink}>
                    <Image priority={true} className={styles.logo} src={logo} alt="Ninjaz Logo"/>
                </Link>

                <nav className={styles.nav}>
                    {items(styles.list)}
                </nav>

                <div className={styles.authButtons}>
                    <MainButton color="primary">Login</MainButton>
                    <MainButton color="info">Sign Up</MainButton>
                </div>

                <button className={styles.mobileMenuButton} onClick={toggleMobileNav}>
                    {showMobileNav ? (
                        <svg className={styles.menuIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    ) : (
                        <svg className={styles.menuIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    )}
                </button>
            </div>

            {showMobileNav && (
                <div className={styles.mobileMenu}>
                    {items(styles.mobileList, true)}
                </div>
            )}
        </header>
    );
}